import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';

import { checkAndRoun } from '../../../../../helpers/topicsHelpers';
import { roundTo } from '../../../../../helpers/helpers';
import { UK_PRIVATE_COMPANY_INSIGHTS_PATH } from '../../../../../data/ukPrivateCompanyInsights';

import Tooltip from '../../../../Tooltip';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

const EquityItem = (props) => {
  const {
    activeType, activeTime, showPeriodChange, isOdd, currentItem,
    isYtd,
  } = props;

  return (
    <div className={cx('fundraisers-body-item-holder', { odd: isOdd, is_change: showPeriodChange })}>
      <div className={cx('fundraisers-body-item', 'year', { is_change: showPeriodChange && !isYtd })}>
        <div className={Styles['fundraisers-body-item-title']}>
          {isYtd ? 'YTD ' : ''}
          {currentItem.currentMonth}
          <br />
          {' '}
          {currentItem.currentYear}
        </div>
        <div className={Styles['fundraisers-body-item-value']}>
          <Link
            to={`${UK_PRIVATE_COMPANY_INSIGHTS_PATH}/top-equity-fundraisers/date/${currentItem.currentMonthNumber}-${currentItem.currentYear}`}
          >
            {activeType === 'count' ? currentItem.transactionCount : checkAndRoun(currentItem.fundsRaised || 0, 2, true, true, true)}
          </Link>
        </div>
      </div>
      {showPeriodChange && !isYtd && (
        <>
          <div className={cx('fundraisers-body-item', 'changes')}>
            <div className={Styles['fundraisers-body-item-title']}>
              <Tooltip
                hasBigScreenDesign
                dynamicPosition
                renderOutside
                hideWithOverflow
                delayTooltip={3000}
                contentStyle={{
                  left: '50%',
                  transform: 'translate(-50%, calc(-100% - 10px))',
                }}
                icon={(
                  <>
                    {activeTime === 'monthly' ? 'MoM' : 'QoQ'}
                    <br />
                    Change
                  </>
                )}
              >
                <>
                  {activeTime === 'monthly' ? 'Month on Month' : 'Quarter on Quarter'}
                  Change
                </>
              </Tooltip>
            </div>
            <div className={Styles['fundraisers-body-item-value']}>
              {activeType === 'count' ? roundTo(currentItem.momChangesCount || 0, 2) : roundTo(currentItem.momChanges || 0, 2)}
              %
            </div>
          </div>
          <div className={cx('fundraisers-body-item', 'changes')}>
            <div className={Styles['fundraisers-body-item-title']}>
              <Tooltip
                hasBigScreenDesign
                dynamicPosition
                renderOutside
                hideWithOverflow
                delayTooltip={3000}
                contentStyle={{
                  left: '50%',
                  transform: 'translate(-50%, calc(-100% - 10px))',
                }}
                icon={(
                  <>
                    YoY
                    <br />
                    Change
                  </>
                )}
              >
                Year on Year Change
              </Tooltip>
            </div>
            <div className={Styles['fundraisers-body-item-value']}>
              {activeType === 'count' ? roundTo(currentItem.yoyChangesCount || 0, 2) : roundTo(currentItem.yoyChanges || 0, 2)}
              %
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default EquityItem;
